/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressDto,
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    FailureCreatorTypes,
    FailureCreatorTypesFromJSON,
    FailureCreatorTypesFromJSONTyped,
    FailureCreatorTypesToJSON,
    PhoneDto,
    PhoneDtoFromJSON,
    PhoneDtoFromJSONTyped,
    PhoneDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReportFailureCommand
 */
export interface ReportFailureCommand {
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    deviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    identifier?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ReportFailureCommand
     */
    reportedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReportFailureCommand
     */
    closedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ReportFailureCommand
     */
    deadline?: Date;
    /**
     * 
     * @type {AddressDto}
     * @memberof ReportFailureCommand
     */
    address?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    typeId: string;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    expanseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    description1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    natureId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    description2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    optimalDeadlineDaysId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    statusId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    stateChangeReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    parentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    contractorId?: string | null;
    /**
     * 
     * @type {FailureCreatorTypes}
     * @memberof ReportFailureCommand
     */
    creatorType?: FailureCreatorTypes;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    notifierFamilyname: string;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    notifierMiddlename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    notifierForename?: string | null;
    /**
     * 
     * @type {PhoneDto}
     * @memberof ReportFailureCommand
     */
    notifierPhone?: PhoneDto;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    notifierEmail: string;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    comment?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportFailureCommand
     */
    repairmanIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ReportFailureCommand
     */
    townId?: string | null;
}

export function ReportFailureCommandFromJSON(json: any): ReportFailureCommand {
    return ReportFailureCommandFromJSONTyped(json, false);
}

export function ReportFailureCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportFailureCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'deviceId': !exists(json, 'deviceId') ? undefined : json['deviceId'],
        'identifier': !exists(json, 'identifier') ? undefined : json['identifier'],
        'reportedAt': !exists(json, 'reportedAt') ? undefined : (new Date(json['reportedAt'])),
        'closedAt': !exists(json, 'closedAt') ? undefined : (json['closedAt'] === null ? null : new Date(json['closedAt'])),
        'deadline': !exists(json, 'deadline') ? undefined : (new Date(json['deadline'])),
        'address': !exists(json, 'address') ? undefined : AddressDtoFromJSON(json['address']),
        'typeId': json['typeId'],
        'expanseId': !exists(json, 'expanseId') ? undefined : json['expanseId'],
        'description1': !exists(json, 'description1') ? undefined : json['description1'],
        'natureId': !exists(json, 'natureId') ? undefined : json['natureId'],
        'description2': !exists(json, 'description2') ? undefined : json['description2'],
        'optimalDeadlineDaysId': !exists(json, 'optimalDeadlineDaysId') ? undefined : json['optimalDeadlineDaysId'],
        'statusId': !exists(json, 'statusId') ? undefined : json['statusId'],
        'stateChangeReason': !exists(json, 'stateChangeReason') ? undefined : json['stateChangeReason'],
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
        'contractorId': !exists(json, 'contractorId') ? undefined : json['contractorId'],
        'creatorType': !exists(json, 'creatorType') ? undefined : FailureCreatorTypesFromJSON(json['creatorType']),
        'notifierFamilyname': json['notifierFamilyname'],
        'notifierMiddlename': !exists(json, 'notifierMiddlename') ? undefined : json['notifierMiddlename'],
        'notifierForename': !exists(json, 'notifierForename') ? undefined : json['notifierForename'],
        'notifierPhone': !exists(json, 'notifierPhone') ? undefined : PhoneDtoFromJSON(json['notifierPhone']),
        'notifierEmail': json['notifierEmail'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'repairmanIds': !exists(json, 'repairmanIds') ? undefined : json['repairmanIds'],
        'townId': !exists(json, 'townId') ? undefined : json['townId'],
    };
}

export function ReportFailureCommandToJSON(value?: ReportFailureCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deviceId': value.deviceId,
        'identifier': value.identifier,
        'reportedAt': value.reportedAt === undefined ? undefined : (value.reportedAt.toISOString()),
        'closedAt': value.closedAt === undefined ? undefined : (value.closedAt === null ? null : value.closedAt.toISOString()),
        'deadline': value.deadline === undefined ? undefined : (value.deadline.toISOString()),
        'address': AddressDtoToJSON(value.address),
        'typeId': value.typeId,
        'expanseId': value.expanseId,
        'description1': value.description1,
        'natureId': value.natureId,
        'description2': value.description2,
        'optimalDeadlineDaysId': value.optimalDeadlineDaysId,
        'statusId': value.statusId,
        'stateChangeReason': value.stateChangeReason,
        'parentId': value.parentId,
        'contractorId': value.contractorId,
        'creatorType': FailureCreatorTypesToJSON(value.creatorType),
        'notifierFamilyname': value.notifierFamilyname,
        'notifierMiddlename': value.notifierMiddlename,
        'notifierForename': value.notifierForename,
        'notifierPhone': PhoneDtoToJSON(value.notifierPhone),
        'notifierEmail': value.notifierEmail,
        'comment': value.comment,
        'repairmanIds': value.repairmanIds,
        'townId': value.townId,
    };
}


